import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { TbWorld } from 'react-icons/tb';
import { MdCancel, MdOutlineAttachEmail, MdOutlineReceiptLong, MdOutlineTextsms, MdPhoneInTalk } from 'react-icons/md';
import { AppIconType } from '../typegen/app-icon-type';
import { BiBarcodeReader, BiSolidCart } from 'react-icons/bi';
import { TbNumber123 } from 'react-icons/tb';
import { TiHome } from 'react-icons/ti';
import { HiMiniNoSymbol, HiPhone } from 'react-icons/hi2';
import { BsCash, BsFillTrash3Fill } from 'react-icons/bs';
import { BiError, BiMinus, BiPlus, BiSolidCheckCircle, BiSolidXCircle, BiChevronDown } from 'react-icons/bi';
import { LiaMoneyCheckAltSolid } from 'react-icons/lia';
import { BsCreditCard } from 'react-icons/bs';
import { BiSolidPencil } from 'react-icons/bi';
import { IoArrowForwardCircleSharp } from 'react-icons/io5';
import { RiInboxUnarchiveLine } from 'react-icons/ri';

export const icons: Record<AppIconType, AppIcon> = {
	[AppIconType.AcceptSolid]: FaCheck,
	[AppIconType.CancelSolid]: FaTimes,
	[AppIconType.CancelRoundedSolid]: MdCancel,
	[AppIconType.LanguageSolid]: TbWorld,
	[AppIconType.BlackArrowSolid]: IoArrowBackCircleSharp,
	[AppIconType.Barcode]: BiBarcodeReader,
	[AppIconType.Number123Solid]: TbNumber123,
	[AppIconType.HomeSolid]: TiHome,
	[AppIconType.PhoneSolid]: HiPhone,
	[AppIconType.Cash]: BsCash,
	[AppIconType.Card]: BsCreditCard,
	[AppIconType.Check]: LiaMoneyCheckAltSolid,
	[AppIconType.Error]: BiError,
	[AppIconType.Pencil]: BiSolidPencil,
	[AppIconType.CircleArrowRight]: IoArrowForwardCircleSharp,
	[AppIconType.Cart]: BiSolidCart,
	[AppIconType.Delete]: BsFillTrash3Fill,
	[AppIconType.Minus]: BiMinus,
	[AppIconType.Plus]: BiPlus,
	[AppIconType.CheckSolid]: BiSolidCheckCircle,
	[AppIconType.XSolid]: BiSolidXCircle,
	[AppIconType.ChevronDown]: BiChevronDown,
	[AppIconType.PrintReceipt]: MdOutlineReceiptLong,
	[AppIconType.Sms]: MdOutlineTextsms,
	[AppIconType.EmailAttahchment]: MdOutlineAttachEmail,
	[AppIconType.MiniNo]: HiMiniNoSymbol,
	[AppIconType.RiInboxUnarchiveLine]: RiInboxUnarchiveLine,
	[AppIconType.MdPhoneInTalk]: MdPhoneInTalk,
};
